import React, { useState, useEffect, useRef } from "react";

//created components
import ShoppingArticle from '../shoppingarticle.js/ShoppingArticle.jsx'

//selectors for redux :
import { useSelector, useDispatch } from "react-redux";
import { getIdSpot, getLivraison, getRidingPeriod, getPanier, getShowPanier } from "../../../../store/selectors.js";
import { showPanierSlice } from "../../../../store/showPanierSlice.js";

//data
import taglist from "../../../../database/taglist.json";

//MUI Components
import Button from '@mui/material/Button';

//Translate utils :
import { translator } from "../../../../utils/translator.js"
//import { useSelector, useDispatch } from "react-redux";
import { getLang } from "../../../../store/selectors.js"; //global state : shopping state
//const lang = useSelector(getLang) //global state : language
// translator(original, lang, ref)

function ShoppingGallery({ articles, duree, managerMode }) { // component to manage the first step of shopping : choosing place and time


    let [filteredArticles, setFilteredArticles] = useState(articles);
    let [currentTag, setCurrentTag] = useState(0);
    let [scrolled, setScrolled] = useState(0);
    const divGallery = useRef();

    const dispatch = useDispatch();
    let panier = useSelector(getPanier);
    const lang = useSelector(getLang) //global state : language


    useEffect(() => {
        //console.log(currentTag);
        if (currentTag === 0) {
            setFilteredArticles(articles);
        }
        else {
            let newList = [];
            articles.map((art) => {
                let tags = art.taglist.split(",");
                if (tags.filter((tag) => parseInt(tag) === currentTag).length > 0) {
                    newList.push(art);
                }
            });
            setFilteredArticles(newList);
        }

        if (divGallery.current) {
            let deltaHeight = divGallery.current.scrollTop;
            handlePos(deltaHeight);
        }

        const handleScroll = () => {

            if (divGallery.current) {
                let deltaHeight = divGallery.current.getBoundingClientRect().y;
                handlePos(deltaHeight);
            }

        };

        window.addEventListener("scroll", handleScroll);
        // Cleanup: Remove event listener on component unmount
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };

    }, [currentTag]);

    useEffect(() => {
        setFilteredArticles(articles);

    }, [articles]);



    function handlePos(y) {
        setScrolled(y)
    }

    const finalTagList = taglist;

    function filterArticles(tag) {
        console.log(tag);
        setCurrentTag(tag);

    }

    function handleOpen() {
        dispatch(showPanierSlice.actions.setShowPanier(true));
    }



    return (
        <div >
            <div className="shopping-gallery" ref={divGallery}>
                {scrolled < 0 ?
                    <div className="shopping-gallery-sticky">
                        <Button
                            className="shopping-gallery-bottom-bouton-panier"
                            disabled={panier.length === 0}
                            variant="outlined"
                            onClick={_ => handleOpen()}
                        >{translator("Voir le panier : ", lang, "infosPanierVoir")}</Button>
                    </div>
                    : null}

                <div className="tags">
                    <div className="tags-list">
                        <div className="tags-list-left">
                            <p className="tags-title">Filtres : </p>
                        </div>
                        <div className="tags-list-right">
                            {finalTagList.map((tag) => (
                                <p key={tag.id} className={tag.id === currentTag ? "tags-list-item tags-list-item-selected " : "tags-list-item"} onClick={_ => filterArticles(tag.id)}>{tag.label}</p>
                            ))}
                        </div>

                    </div>
                </div>

                <div className="shopping-gallery-middle">
                    {filteredArticles.map((article) => <ShoppingArticle key={article.id_article} article={article} duree={duree} />)}
                </div>

                <div className="shopping-gallery-bottom">
                    <Button
                        className="shopping-gallery-bottom-bouton-panier"
                        disabled={panier.length === 0}
                        variant="contained"
                        onClick={_ => handleOpen()}
                    >{translator("Voir le panier : ", lang, "infosPanierVoir")}</Button>
                </div>



            </div>

        </div>

    )
}




export default ShoppingGallery